<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="selectedMealsList"
      :items-per-page="10"
      :mobile-breakpoint="0"
    >
      <template v-slot:[`item.date`]="{ item }">
        <ShowAllMenuItems :dateMenu="item" />
      </template>

      <!-- <template v-slot:[`item.date`]="{ item }">
        {{ item.date | moment("MMM DD YYYY") }}
      </template> -->
      <template v-slot:[`item.last_modified_by`]="{ item }">
        <span>{{ item.last_modified_by || "" }}</span>
      </template>

      <template v-slot:[`item.last_modified_date`]="{ item }">
        <span v-if="item.last_modified_date != 'Invalid Date'">
          {{ item.last_modified_date | moment("MMM DD YYYY") }}
        </span>
      </template>
      <template v-slot:[`item.remarks`]="{ item }">
        <span>{{ item.isPaused ? "Paused" : item.freezeRemark }}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <span v-if="item.isFrozen">
          <v-chip color="#9B1D1F" text-color="white" small>
            <v-icon left small>mdi-snowflake</v-icon>
            Frozen
          </v-chip>
        </span>
        <span v-else-if="item.isPaused">
          <v-chip color="#9B1D1F" text-color="white" small>
            <v-icon left small>mdi-pause-circle</v-icon>
            Paused
          </v-chip>
        </span>
        <span v-else>
          <CustomerMealSelectionPopup
            :selectedDay="item"
            v-if="checkActivePackage()"
            :activePackage="activePackage"
          />
        </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ShowAllMenuItems from "./ShowAllMenuItems.vue";
import CustomerMealSelectionPopup from "./CustomerMealSelectionPopup.vue";
import moment from "moment";
import { Utils } from "../../../utils/utils";
export default {
  components: { ShowAllMenuItems, CustomerMealSelectionPopup },

  props: {
    selectedPackage: {
      require: true,
    },
  },

  watch: {
    selectedPackage: {
      handler(newVal) {
        this.activePackage = newVal;
        this.getAllMenu();
      },
      deep: true,
    },
  },
  methods: {
    async getCustomerFreezeDays() {
      this.loading = true;

      return new Promise((resolve, reject) => {
        this.$apollo
          .query({
            query: require("@/customer/components/freeze/api/getCustomerFreezeDays.graphql"),
            variables: {
              customer: this.$route.query.customerId,
            },
            fetchPolicy: 'network-only',
          })
          .then((data) => {
            this.loading = false;
            if (data.data.getCustomerFreezeDays) {
              this.freezeDays = data.data.getCustomerFreezeDays;
            }
            resolve(this.freezeDays);
          })
          .catch((error) => {
            this.loading = false;
            console.log(error);
            reject(error);
          });
      });
    },
    isPackageNotAvailableOnThisDay(date, availabelWeekDaysInNumbers) {
      let day = date.day();
      let available = availabelWeekDaysInNumbers.filter((x) => x == day);
      return available.length > 0 ? false : true;
    },
    checkActivePackage() {
      return Utils.checkIsActiveOrUpcomingPackage(this.activePackage);
    },

    getAllDates(activePackage, freezeDays) {
      let fromDate = new Date(parseInt(activePackage.start_date));
      const toDate = new Date(parseInt(activePackage.end_date));
      let momentFromDate = moment(fromDate).add(3, "h").startOf("day");
      let momentToDate = moment(toDate).add(3, "h").endOf("day");
      var dateArray = new Array();

      let availableWeekDays = activePackage.package.availableChoices[0].availableDays;

      let availabelWeekDays = this.getAvailabelWeekDaysInNumbers(availableWeekDays);

      while (momentFromDate <= momentToDate) {
        let isFreezedDay = false;
        let freezeRemark = "";
        if (freezeDays.length > 0) {
          freezeDays.forEach((freeze) => {
            let freezeFromDate = moment(parseInt(freeze.fromDate)).startOf("day");
            let freezeToDate;

            if (freeze.isActive) {
              freezeToDate = freeze.endDate
                ? moment(parseInt(freeze.endDate)).endOf("day")
                : moment(toDate).endOf("day");
            } else if (freeze.endDate) {
              // Completed freeze — mark those dates as frozen in UI
              freezeToDate = moment(parseInt(freeze.endDate)).endOf("day");
            } else {
              return;
            }

            if (momentFromDate.isBetween(freezeFromDate, freezeToDate, undefined, "[]")) {
              isFreezedDay = true;
              freezeRemark = freeze.remark || "";
            }
          });
        }

        if (!this.isPackageNotAvailableOnThisDay(momentFromDate, availabelWeekDays)) {
          dateArray.push({
            date: momentFromDate.toDate(),
            isFrozen: isFreezedDay,
            freezeRemark: freezeRemark,
          });
        }

        momentFromDate.add(1, "days");
      }
      return dateArray;
    },

    async getAllMenu() {
      let freeze = await this.getCustomerFreezeDays();
      const allDates = this.getAllDates(this.activePackage, freeze);

      let dateWiseMenu = new Array();
      let selectedMenu = this.activePackage.selected_menu;
      let index = 0;
      allDates.forEach((element) => {
        let seletedItem = {};
        seletedItem.date = element.date;
        seletedItem.isFrozen = element.isFrozen;
        seletedItem.freezeRemark = element.freezeRemark || "";
        seletedItem.index = index;

        if (selectedMenu) {
          let formattedDate = moment(element.date).format("MM-DD-YYYY");

          const matchingEntries = selectedMenu.filter((x) => {
            const ts = Number(x.date);
            const xDate = (!isNaN(ts) && ts > 1e10) ? new Date(ts) : x.date;
            return moment(xDate).format("MM-DD-YYYY") == formattedDate;
          });
          // Prioritise the paused entry if duplicates exist (can occur from a prior
          // data bug where Date.parse("MM-DD-YYYY") returned NaN and the old entry
          // was not removed before the pause entry was pushed).
          let menu = matchingEntries.find(x => x.is_paused) || matchingEntries[0];

          if (menu) {
            seletedItem = {
              date: element.date,
              allMeals: menu.menu_category,
              last_modified_by: menu.last_modified_by,
              last_modified_name: menu.last_modified_name || null,
              last_modified_date: new Date(parseInt(menu.last_modified_date)),
              index: index,
              isPaused: menu.is_paused,
              isFrozen: element.isFrozen,
              freezeRemark: element.freezeRemark || "",
            };
          }
        } else {
          seletedItem = {
            date: element.date,
            allMeals: [],
            last_modified_by: "",
            last_modified_date: "",
            index: index,
            isPaused: false,
            isFrozen: element.isFrozen,
            freezeRemark: element.freezeRemark || "",
          };
        }

        dateWiseMenu.push(seletedItem);
        index = index + 1;
      });

      dateWiseMenu.sort(function (a, b) {
        return new Date(a.date) - new Date(b.date);
      });
      this.selectedMealsList = dateWiseMenu;
    },
    getAvailabelWeekDaysInNumbers(availabelWeekDays) {
      let availabelWeekDaysInNumbers = new Array(0);
      if (availabelWeekDays == null) return [];
      availabelWeekDays.forEach((element) => {
        switch (element) {
          case "Sunday":
            availabelWeekDaysInNumbers.push(0);
            break;
          case "Monday":
            availabelWeekDaysInNumbers.push(1);
            break;
          case "Tuesday":
            availabelWeekDaysInNumbers.push(2);
            break;
          case "Wednesday":
            availabelWeekDaysInNumbers.push(3);
            break;
          case "Thursday":
            availabelWeekDaysInNumbers.push(4);
            break;
          case "Friday":
            availabelWeekDaysInNumbers.push(5);
            break;
          case "Saturday":
            availabelWeekDaysInNumbers.push(6);
            break;
          default:
        }
      });
      return availabelWeekDaysInNumbers;
    },
    onPackageChange() {
      this.getAllMenu();
    },
  },

  created() {
    this.activePackage = this.selectedPackage;
    this.getAllMenu();
  },
  data() {
    return {
      activePackage: "",
      runningPackages: [],
      selectedMealsList: [],
      headers: [
        { text: "Date", value: "date", width: 150 },
        { text: "Updated By", value: "last_modified_by" },
        { text: "Updated Date", value: "last_modified_date" },
        { text: "Remarks", value: "remarks", sortable: false },
        { text: "Action", value: "actions", sortable: false },
      ],
    };
  },
};
</script>